import { InputSearchField, LoaderBar, PrimaryButton, ScreenHeader } from 'components'
import { GetCompetitionsList, useDebounce } from 'hooks'
import { CompetitionList } from 'page-components'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HeaderWrapper } from '../dashboard'

export const CompetitionsScreen = () => {
  const {
    data: fetchedData,
    filter,
    pageChanged,
    total,
    loading,
    updateFilter,
  } = GetCompetitionsList()
  const [data, setData] = useState([])
  const navigate = useNavigate()
  const [search, setSearch] = useState()
  const finalSearch = useDebounce(search, 1000)

  useEffect(() => {
    if (finalSearch?.trim() || finalSearch?.trim() === '') {
      updateFilter('search', finalSearch?.trim())
    }
  }, [finalSearch])
  // Update local data when fetchedData changes
  useEffect(() => {
    if (fetchedData) {
      setData(fetchedData)
    }
  }, [fetchedData])

  const onDetail = id => navigate(id)

  return (
    <div>
      <div>
        <HeaderWrapper>
          <ScreenHeader text="Manage Competitions" />
          <PrimaryButton className="" onClick={() => navigate('add-edit')}>
            + New Competition
          </PrimaryButton>
        </HeaderWrapper>
      </div>

      <div className="px-5 my-4 mt-3">
        <div className="d-flex justify-content-end">
          <InputSearchField
            placeholder="Search here..."
            onChange={val => setSearch(val)}
            className="w-25 mb-4"
          />
        </div>
        {loading && <LoaderBar />}
        <CompetitionList
          list={data}
          pageChanged={pageChanged}
          page={filter.page}
          loading={loading}
          total={total}
          onDetail={onDetail}
          setList={setData} // ✅ Pass setData here for user-side delete
        />
      </div>
    </div>
  )
}
